export function getElementDimensions(el: HTMLDivElement | null) {
  if (el) {
    console.log('Box dimensions:', {
      width: el.offsetWidth,
      height: el.offsetHeight,
      clientWidth: el.clientWidth,
      clientHeight: el.clientHeight,
      scrollWidth: el.scrollWidth,
      scrollHeight: el.scrollHeight,
    });
  }
}
